export default __webpack_public_path__ + "static/media/PeopleDiscussionHeader.66a7d9ba.jpg";